<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { Button, ScrollArea } from '@rapoo/element'
  import { ShaftType } from '@rapoo/device-sdk'
  import shaftImg from '@/assets/images/devices/keys/shaft.png'

  const { t } = useI18n()

  const shaftTypeOptions = computed(() => [
    { label: t('itinerary.shaftPanel.types.CiYuPro'), value: ShaftType.CiYuPro },
    { label: t('itinerary.shaftPanel.types.CiYuGaming'), value: ShaftType.CiYuGaming },
    { label: t('itinerary.shaftPanel.types.WanCiWangRgb'), value: ShaftType.WanCiWangRgb },
    { label: t('itinerary.shaftPanel.types.WanCiWangPom'), value: ShaftType.WanCiWangPom },
    { label: t('itinerary.shaftPanel.types.WanCiWang'), value: ShaftType.WanCiWang },
    { label: t('itinerary.shaftPanel.types.TianWangEsports'), value: ShaftType.TianWangEsports },
    { label: t('itinerary.shaftPanel.types.TianWangStandard'), value: ShaftType.TianWangStandard },
    { label: t('itinerary.shaftPanel.types.KailhCiShen'), value: ShaftType.KailhCiShen },
    { label: t('itinerary.shaftPanel.types.TaiShanGt'), value: ShaftType.TaiShanGt },
    { label: t('itinerary.shaftPanel.types.CiPo'), value: ShaftType.CiPo },
    { label: t('itinerary.shaftPanel.types.XingLan'), value: ShaftType.XingLan },
    { label: t('itinerary.shaftPanel.types.LiuLi'), value: ShaftType.LiuLi },
  ])

  defineProps<{
    selectedShaftType: number | null
    saveDisabled: boolean
  }>()

  const emit = defineEmits<{
    (e: 'select', shaftType: number): void
    (e: 'save'): void
  }>()
</script>

<template>
  <div class="w-full flex justify-center">
    <div class="flex flex-col glass-frosted relative rounded-8xl w-250 h-67.5 p-4">
      <div class="w-full flex justify-between items-start">
        <h3 class="text-l-medium text-black-white">{{ $t('itinerary.shaftPanel.title') }}</h3>
        <Button color="normal" size="sm" class="h-8" :disabled="saveDisabled" @click="emit('save')">
          {{ $t('common.save') }}
        </Button>
      </div>
      <ScrollArea class="mt-2 flex-1">
        <div class="flex flex-wrap gap-2.5">
          <div
            v-for="shaft in shaftTypeOptions"
            :key="shaft.value"
            class="relative flex flex-col justify-center items-center gap-1 w-28 h-28 bg-key rounded-t-l rounded-b-l border transition-colors cursor-pointer"
            :class="
              shaft.value === selectedShaftType
                ? 'border-brand-blue1'
                : 'border-transparent hover:border-brand-blue1'
            "
            @click="emit('select', shaft.value)"
          >
            <img :src="shaftImg" class="w-17 object-contain" />
            <span class="text-s-medium text-black-white">{{ shaft.label }}</span>
            <div
              class="absolute top-1.5 right-1.5 flex items-center justify-center size-8 rounded-m bg-brand-blue1 text-m-medium"
            >
              <span class="text-m-medium text-white font-[Barlow]">G{{ shaft.value }}</span>
            </div>
          </div>
        </div>
      </ScrollArea>
    </div>
  </div>
</template>
